import React from 'react'
import PropTypes from 'prop-types'
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbList,
    BreadcrumbSeparator
} from '@/components/ui/breadcrumb'
import {Blocks} from '@builder.io/sdk-react'

export const BuilderBreadcrumb = ({crumbs, builderBlock, separator, attributes}) => {
    return (
        <Breadcrumb {...attributes} data-testid="breadcrumb-Breadcrumb">
            <BreadcrumbList data-testid="breadcrumb-BreadcrumbList">
                {crumbs?.map((crumb, index) => {
                    const isBeforeLastCrumb = index < crumbs.length - 1
                    return (
                        <React.Fragment key={`breadcrumb-item-${index}`}>
                            <BreadcrumbItem data-testid="breadcrumb-BreadcrumbItem">
                                <Blocks
                                    path={`component.options.customCrumbs.${index}.content`}
                                    blocks={[crumb]}
                                    parent={builderBlock?.id}
                                    data-testid="breadcrumb-Blocks"
                                />
                            </BreadcrumbItem>
                            {isBeforeLastCrumb && (
                                <BreadcrumbSeparator data-testid="breadcrumb-BreadcrumbSeparator">
                                    {separator || '>'}
                                </BreadcrumbSeparator>
                            )}
                        </React.Fragment>
                    )
                })}
            </BreadcrumbList>
        </Breadcrumb>
    )
}

BuilderBreadcrumb.propTypes = {
    separator: PropTypes.node,
    crumbs: PropTypes.array,
    builderBlock: PropTypes.object,
    attributes: PropTypes.object
}
